// extracted by mini-css-extract-plugin
export default {"body":"front-doors-page-container-ui--body--0zUDy"};